<template>
  <div class="f-message-history">
    <template v-if="items.length">
      <f-message
        v-for="(message, messageIdx) in items"
        :key="messageIdx"
        :message="message" />
    </template>
    <template v-else>
      <div class="text-medium mt-4 text-center">{{ $t('message.noMessage') }}</div>
    </template>
  </div>
</template>
<script>
import FMessage from './FMessage.vue'

export default {
  components: { FMessage },
  name: 'f-message-history',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>
